<template>
  <!-- 胚布档案详情 -->
  <div class="rzy-page">
    <div class="rzy-top-bar">
      <el-button
        type="primary"
        @click="refreshPage()"
        style=""
        size="mini"
        icon="el-icon-refresh"
        >刷新</el-button
      >

      <el-button
        type="primary"
        @click="previousRecord()"
        style=""
        size="mini"
        icon="el-icon-arrow-up"
        >上一条
      </el-button>
      <el-button
        type="primary"
        @click="nextRecord()"
        style=""
        size="mini"
        icon="el-icon-arrow-down"
        >下一条
      </el-button>

      <el-button
        type="primary"
        @click="initPrint('peiBuDetail')"
        size="mini"
        icon="el-icon-printer"
        >打印
      </el-button>

      <el-button
        v-if="$store.state.role.role.includes('material.edit')"
        type="success"
        @click="editPeiBu()"
        size="mini"
        icon="el-icon-edit"
        >编辑</el-button
      >
    </div>

    <div id="peiBuDetail" class="wuliaoDetail">
      <el-descriptions border size="medium" column="4">
        <el-descriptions-item label="物料编号">{{
          wuLiaoInfo.number
        }}</el-descriptions-item>
        <el-descriptions-item label="物料名称">{{
          wuLiaoInfo.name
        }}</el-descriptions-item>
        <el-descriptions-item label="单位">{{
          wuLiaoInfo.unit
        }}</el-descriptions-item>
        <el-descriptions-item label="启用">
          <el-radio-group disabled="isDisabled" v-model="wuLiaoInfo.active">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-descriptions-item>

        <el-descriptions-item label="物料类型">{{
          wuLiaoInfo.kind_change
        }}</el-descriptions-item>
        <el-descriptions-item label="物料分组">{{
          wuLiaoInfo.group_change
        }}</el-descriptions-item>
        <el-descriptions-item label="物料规格">{{
          wuLiaoInfo.spec
        }}</el-descriptions-item>
        <!-- 占位用，别删除 -->
        <el-descriptions-item label="">{{
          wuLiaoInfo.XXXX
        }}</el-descriptions-item>

        <el-descriptions-item label="牵拉系数">{{
          wuLiaoInfo.stretchRate_change
        }}</el-descriptions-item>
        <el-descriptions-item label="D数">{{
          wuLiaoInfo.dcount_change
        }}</el-descriptions-item>
        <el-descriptions-item label="支数">{{
          wuLiaoInfo.zcount_change
        }}</el-descriptions-item>
        <!-- 占位用，别删除 -->
        <el-descriptions-item label="">{{
          wuLiaoInfo.XXXX
        }}</el-descriptions-item>

        <el-descriptions-item label="备注">{{
          wuLiaoInfo.remark
        }}</el-descriptions-item>
      </el-descriptions>
    </div>

    <el-row :gutter="10" style="margin-top:10px" class="wuliaoPanels">
      <el-col :lg="12" :md="24" :sm="24">
        <div class="col-header">物料规格</div>
        <el-table
          :data="wuLiaoInfo.specItems"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '0px' }"
          :header-cell-style="{ padding: 0 }"
          border
        >
          <el-table-column label="行" type="index" :index="indexMethod">
          </el-table-column>
          <el-table-column
            v-for="(obj, key, index) in specItemsKeys"
            :key="index"
            :label="obj.value"
            :width="obj.width"
            :prop="key"
            align="center"
          />
        </el-table>
      </el-col>
      <el-col :lg="12" :md="24" :sm="24">
        <div class="col-header">物料组成</div>
        <el-table
          :data="wuLiaoInfo.partItems"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '0px' }"
          :header-cell-style="{ padding: 0 }"
          border
        >
          <el-table-column label="行" type="index" :index="indexMethod">
          </el-table-column>
          <el-table-column
            v-for="(obj, key, index) in partItemsKeys"
            :key="index"
            :label="obj.value"
            :width="obj.width"
            :prop="key"
            align="center"
          />
        </el-table>
      </el-col>
    </el-row>

    <div class="rzy-top-bar" style="margin-top: 10px;">
      <div>
        制单时间: {{ this.utils.timestampToTime(this.wuLiaoInfo.createTime) }}
      </div>
      <div style="margin-left: auto;">
        停用时间: {{ this.utils.timestampToTime(this.wuLiaoInfo.checkTime) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      wuLiaoInfo: {
        // 调试用假数据--正式版注释掉 --sta
        // number: '测试编号', // 物料编号
        // name: '测试名称', // 物料名称
        // unit: '测试单位', //单位
        // active: 1, //lable前有冒号使用数字 //启用
        // //----
        // kind: '测试类型', //胚布类型
        // group: '测试分组', //物料分组
        // spec: '测试规格', //规格
        // //----
        // density: Math.round(0).toFixed(2), //针密
        // //----
        // remark: '测试备注', //备注
        // //----
        // createTime: '2022-04-19',
        // checkTime: '2022-04-19',
        // 调试用假数据--正式版注释掉 --end

        specItems: [], //物料规格
        partItems: [], //物料组成
      },

      //物料规格
      specItemsKeys: {
        specName: {
          value: "规格名称",
          width: 100,
        },
        specNumber: {
          value: "货号",
          width: 150,
        },
        isDefault_change: {
          value: "默认",
          width: 150,
        },
      },

      //物料组成
      partItemsKeys: {
        number: {
          value: "物料编码",
          width: 150,
        },
        name: {
          value: "物料名称",
          width: 150,
        },
        specNumber: {
          value: "规格编码",
          width: 150,
        },
        specName: {
          value: "规格名称",
          width: 150,
        },
        percent: {
          value: "占比",
          width: 100,
        },
        remark: {
          value: "备注",
          width: 450,
        },
      },

      lastWuLiaoId: 0, // 上一条/下一条 切换后，记录最新的 物料ID
    };
  },
  methods: {
    // 根据ID，获取 物料 信息
    getWuLiaoInfo(wuLiaoId) {
      this.$requestBase({
        url: "v1/material/detail",
        method: "get",
        params: {
          id: wuLiaoId,
        },
      }).then((res) => {
        res = res.data;
        this.wuLiaoInfo = res;
        this.formatResponse();
      });
    },

    //格式化 返回结果
    formatResponse() {
      //对某些字段 做 显示变换。
      if (this.wuLiaoInfo.useBatch === true) {
        this.wuLiaoInfo.active = 1; //启用
      } else {
        this.wuLiaoInfo.active = 2; //停用
      }
      // console.log('this.wuLiaoInfo.active=', this.wuLiaoInfo.active)

      switch (this.wuLiaoInfo.kind) {
        case "PB":
          this.wuLiaoInfo.kind_change = "胚布";
          break;
        case "YL":
          this.wuLiaoInfo.kind_change = "原料";
          break;
        default:
          this.wuLiaoInfo.kind_change = "无法识别的类型";
          break;
      }

      switch (this.wuLiaoInfo.group) {
        case "PB":
          this.wuLiaoInfo.group_change = "胚布";
          break;
        case "YL":
          this.wuLiaoInfo.group_change = "原料";
          break;
        default:
          this.wuLiaoInfo.group_change = "无法识别的分组";
          break;
      }

      //后台 用integer存储，放大100倍。
      this.wuLiaoInfo.stretchRate_change = (
        this.wuLiaoInfo.stretchRate / 100
      ).toFixed(2);
      this.wuLiaoInfo.dcount_change = (this.wuLiaoInfo.dcount / 100).toFixed(2);
      this.wuLiaoInfo.zcount_change = (this.wuLiaoInfo.zcount / 100).toFixed(2);

      //boolean 型切换成 中文显示。
      for (let i = 0; i < this.wuLiaoInfo.specItems.length; i++) {
        // console.log('i=',i)
        // console.log('isDefault=',this.wuLiaoInfo.specItems[i].isDefault)

        if (this.wuLiaoInfo.specItems[i].isDefault === true) {
          this.wuLiaoInfo.specItems[i].isDefault_change = "是";
        }
      }
    },

    // 在打印当前报表前，拼接title
    initPrint(id) {
      this.utils.printTable(id, `胚布档案详情`);
    },
    // 刷新
    refreshPage() {
      this.getWuLiaoInfo(this.lastWuLiaoId);
      this.avoidMultiPop("刷新成功。");
    },
    // 上一条记录
    previousRecord() {
      this.$requestBase({
        url: "v1/material/prev",
        method: "get",
        params: {
          id: this.lastWuLiaoId,
          kind: "YL", //胚布 = PB, 原料 = YL。
        },
      }).then((res) => {
        res = res.data;

        if (res != undefined) {
          this.wuLiaoInfo = res;
          this.formatResponse();

          this.lastWuLiaoId = res.id; //更新工单ID
          this.avoidMultiPop("切换下一条记录成功。");
        } else {
          // null 表示数据库 到顶 或者 到底。
          this.avoidMultiPop("没有更多数据。");
        }
      });
    },
    // 下一条记录
    nextRecord() {
      this.$requestBase({
        url: "v1/material/next",
        method: "get",
        params: {
          id: this.lastWuLiaoId,
          kind: "YL", //胚布 = PB, 原料 = YL。
        },
      }).then((res) => {
        res = res.data;

        if (res != undefined) {
          this.wuLiaoInfo = res;
          this.formatResponse();

          this.lastWuLiaoId = res.id; //更新工单ID
          this.avoidMultiPop("切换下一条记录成功。");
        } else {
          // null 表示数据库 到顶 或者 到底。
          this.avoidMultiPop("没有更多数据。");
        }
      });
    },
    //避免重复弹窗
    avoidMultiPop(message) {
      this.$Message.closeAll();
      this.$Message.success(message);
    },

    // 编辑胚布档案
    editPeiBu() {
      this.$router.push({
        path: `../../yuanLiao/yuanLiaoAdd`,
        query: {
          type: 1, //0=新建, 1=编辑.
          //上一条/下一条切换 后 点 编辑，要找最新的id -- sta
          // wuLiaoId: this.$route.params.id,
          wuLiaoId: this.lastWuLiaoId,
          //上一条/下一条切换 后 点 编辑，要找最新的id -- end
        },
      });
    },

    //给 所有 表格 自动 加行号
    indexMethod(index) {
      return index + 1;
    },
  },
  created() {
    this.getWuLiaoInfo(this.$route.params.id);

    this.lastWuLiaoId = this.$route.params.id; //初始化时候 备份 工单ID.
  },
};
</script>

<style lang="scss" scoped></style>
